import React from 'react';
import { Link } from 'react-router-dom';
import CountryClocks from '../CountryClocks/CountryClocks';

function BottemFooter() {
    const menuItems = [
        { id: 1, title: "Home", path: "/" },
        { id: 2, title: "About Us", path: "/about" },
        { id: 3, title: "Services", path: "/services" },
        { id: 4, title: "Our Team", path: "/team" },
        { id: 5, title: "Why Choose Us", path: "/why-choose-us" },
        { id: 6, title: "Our Network", path: "/ournetwork" },
        { id: 7, title: "Blog", path: "/blog" },
        { id: 8, title: "Contact us", path: "/contact" }
    ];

    // Function to scroll to top when a link is clicked
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <div className="bottem-footer">
            {/* Add the CountryClocks component above the menu */}
            <CountryClocks />
            
            <div className="footer-menu-container">
                <div className="footer-menu-border-top"></div>
                <nav className="footer-menu">
                    <ul>
                        {menuItems.map(item => (
                            <li key={item.id} className="footer-menu-item">
                                <Link
                                    to={item.path}
                                    className="footer-menu-link"
                                    onClick={scrollToTop}
                                >
                                    <span className="corner-hover">{item.title}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div className="footer-menu-border-bottom"></div>
            </div>
            <div className='copyright-main'>
                <div className="copyright">
                    <p>© Copyright 2025 Centrex marine services | All Rights Reserved</p>
                    <div>
                        <Link
                            to="https://portfolio-umer-git467s-projects.vercel.app/"
                            className='footerdeveloper-link'
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Site By: MERN By Umer
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BottemFooter;
